import { render } from "./WsServerUrlList.vue?vue&type=template&id=1d37d10d&scoped=true"
import script from "./WsServerUrlList.vue?vue&type=script&lang=js"
export * from "./WsServerUrlList.vue?vue&type=script&lang=js"

import "./WsServerUrlList.vue?vue&type=style&index=0&id=1d37d10d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d37d10d"]])

export default __exports__